import { LUNAR_MESSAGES } from "../data/interpretations.js";

const SYNODIC = 29.530588853;
const KNOWN_NEW_MOON = Date.UTC(2000, 0, 6, 18, 14);

export function lunarPhase(date = new Date()) {
  const days = (date.getTime() - KNOWN_NEW_MOON) / 86400000;
  const age = ((days % SYNODIC) + SYNODIC) % SYNODIC;
  const names = ["New Moon", "Waxing Crescent", "First Quarter", "Waxing Gibbous", "Full Moon", "Waning Gibbous", "Last Quarter", "Waning Crescent"];
  const idx = Math.floor((age / SYNODIC) * 8 + 0.5) % 8;
  return { name: names[idx], message: LUNAR_MESSAGES[names[idx]], age: Math.round(age * 10) / 10, illumination: Math.round(((1 - Math.cos((2 * Math.PI * age) / SYNODIC)) / 2) * 100) };
}

export function captureMeta(date = new Date()) {
  return {
    date: date.toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }),
    time: date.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }),
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || "Local time",
    lunar: lunarPhase(date),
  };
}
